import { Injectable } from '@angular/core'
import { SeTime } from './time'
import { SeTimeRange } from './time-range'
import { SeDate } from './date'
import { SeDateRange } from './date-range'
import { SeDateTimeOptions, SeTimeZoneName, SeDateString, SeDateTimeString } from './date-time-types'
import { seDateTimeConfig } from './date-time-config'

@Injectable({providedIn: 'root'})
export class SeDateTime {

  readonly deviceZone: SeTimeZoneName = seDateTimeConfig.deviceZone

  public date(startValue?: string, options?: SeDateTimeOptions): SeDate {
    return new SeDate(this.dateOrNow(startValue), options || {})
  }

  public dateRange(startValue?: string, endValue?: string, options?: SeDateTimeOptions): SeDateRange {
    return new SeDateRange(this.dateOrNow(startValue), this.dateOrNow(endValue), options || {})
  }

  public time(startValue?: string, options?: SeDateTimeOptions): SeTime {
    return new SeTime(this.dateTimeOrNow(startValue), options || {})
  }

  public timeRange(startValue?: string, endValue?: string, options?: SeDateTimeOptions): SeTimeRange {
    return new SeTimeRange(this.dateTimeOrNow(startValue), this.dateTimeOrNow(endValue), options || {})
  }

  private dateTimeOrNow(value: string): SeDateTimeString {
    if (!value) return
    if (value !== 'now') return value
    const date = new Date()
    return date.toISOString()
  }

  private dateOrNow(value: string): SeDateString {
    if (!value) return
    if (value !== 'now') return value
    const date = new Date()
    const year = date.getFullYear()
    const month = this.pad(date.getMonth() + 1)
    const day = this.pad(date.getDate())
    return `${year}-${month}-${day}`
  }

  private pad(num: number): string {
    return (num < 10) ? `0${num}` : `${num}`
  }

}
